<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>

    <div class="content--box">
      <div
        style="
          font-family: Consolas, 'Courier New', monospace;
          line-height: 19px;
        "
      >
        <div
          style="
            font-family: Consolas, 'Courier New', monospace;
            line-height: 19px;
          "
        >
          <div>
            &nbsp; &nbsp; &nbsp;
            为规范网络餐饮服务食品安全检查管理，保障公众餐饮安全，根据《食品安全法》、《食品安全法实施条例》和《餐饮服务食品安全监督管理办法》等法律、法规及规章，制定本管理制度。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            1、入驻美滋来外卖的商户应依照法律、法规和食品安全标准从事餐饮服务活动，采取有效管理措施，保证食品安全，按照许可范围依法经营，并在网店醒目位置放入食品经营许可证，接受社会监督，承担主体责任。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            2、入驻美滋来外卖的商户应建立本单位食品安全管理组织机构，美滋来外卖配备专职或者兼职经过培训合格的食品安全管理员，对餐饮服务全过程实施内部检查管理并记录，落实责任到人，严格落实监管部门的监管意见和整改要求。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            3、食品安全管理员须认真按照职责要求，组织落实管理人员和从业人员食品安全知识培训、骑手健康管理、索证索票、保温箱清洗消毒、综合检查、设备管理、环境卫生管理等各项食品安全管理制度。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            4、制订定期或不定期食品安全检查计划，采取全面检查、抽查与自查相结合的形式，实行层层监管，主要检查各项制度的贯彻落实情况。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            5、食品安全管理员每天在操作加工时段至少进行一次食品安全检查发现问题，及时告知改进，并做好食品安全检查记录备查。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            6、各岗位负责人、主管人员要服从食品安全管理员检查指导，每天开展岗位或部门自查，及时发现和纠正从业人员违反制度要求操作的行为。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            7、食品安全管理员每月1-2次对各环节进行全面现场检查，发现问题及时反馈，并提出限期改进意见，做好检查记录。
          </div>
          <div>&nbsp; &nbsp; &nbsp; 8、各种检查结果记录归档备查。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
